module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header-sidebar ui sidebar vertical menu visible"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../static/croud-logo.svg")
    },
    on: {
      "click": function($event) {
        _vm.goHome()
      }
    }
  }), _vm._v(" "), _c('nav', [_vm._l((_vm.routes), function(route) {
    return [(route.name || route.title) ? [(route.children) ? [_c('router-link', {
      staticClass: "item",
      attrs: {
        "tag": "a",
        "to": {
          name: route.children[0].name,
          params: {}
        },
        "active-class": "active",
        "exact": ""
      }
    }, [_vm._v("\n                        " + _vm._s(route.title || route.name) + "\n                    ")]), _vm._v(" "), _vm._l((_vm.order(route.children)), function(child) {
      return _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.catagoryOpen(route)),
          expression: "catagoryOpen(route)"
        }],
        staticClass: "submenu"
      }, [_c('router-link', {
        staticClass: "item",
        attrs: {
          "tag": "a",
          "to": {
            name: child.name,
            params: {}
          },
          "active-class": "active"
        }
      }, [_vm._v("\n                            " + _vm._s(child.name) + "\n                        ")])], 1)
    })] : [_c('router-link', {
      staticClass: "item",
      attrs: {
        "tag": "a",
        "to": {
          name: route.name || undefined,
          params: {}
        },
        "active-class": "active",
        "exact": ""
      }
    }, [_vm._v("\n                        " + _vm._s(route.title || route.name) + "\n                    ")])]] : _vm._e()]
  })], 2), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bottom-menu"
  }, [_c('a', {
    attrs: {
      "href": "https://croudsupport.github.io/Croud-Style-Guide/technical/"
    }
  }, [_c('button', {
    staticClass: "ui button mini basic yellow"
  }, [_vm._v("Open Tech Docs")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-c36164d2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navigation.vue
// module id = 1467
// module chunks = 1